import { QueryClientProvider } from "@tanstack/react-query";
import { I18nProvider } from "react-aria-components";
import { RouterProvider } from "react-router-dom";
import { trpc, trpcClient, queryClient } from "@/lib/trpc";
import { router } from "@/router";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/theme-provider";
import { AuthProvider } from "@/lib/auth";
import { ErrorBoundary } from "@/components/error-boundary";
import { TooltipProvider } from "@/components/ui/tooltip";

export function App() {
  return (
    <ErrorBoundary>
      <I18nProvider locale="en-US">
        <trpc.Provider client={trpcClient} queryClient={queryClient}>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <ThemeProvider>
                <TooltipProvider>
                  <RouterProvider router={router} />
                  <Toaster />
                </TooltipProvider>
              </ThemeProvider>
            </AuthProvider>
          </QueryClientProvider>
        </trpc.Provider>
      </I18nProvider>
    </ErrorBoundary>
  );
}
